// extracted by mini-css-extract-plugin
export default {"tabs":"EmployeeDetails_tabs__Eg6vo"};